import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProiectePushNotificationsService } from '../../proiecte-push-notifications.service';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/services/notification.service';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-add-image',
    templateUrl: './add-image.component.html',
    styleUrls: ['./add-image.component.scss']
})
export class AddImageComponent {
    isLoading = false;
    uploading: boolean[] = [];

    form: FormGroup = new FormGroup({
        files: new FormControl(''),
    })

    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    // general success alert
    successTitle: string = environment.config.customNotifications.headers.successForm;
    successIcon: string = environment.config.customNotifications.icons.success;
    successType: string = environment.config.customNotifications.icons.success;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: number,
        private dialogRef: MatDialogRef<AddImageComponent>,
        private proiectePushNotificationsService: ProiectePushNotificationsService,
        public toastr: ToastrService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const filesToSend = this.form.get('files')?.value || [];

        const formData = new FormData();

        filesToSend.forEach((file: any) => {
            formData.append('files[]', file);
        });

        this.proiectePushNotificationsService.sendForm(formData, this.data)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (res: any) => {
                    let response = (typeof res.status_code !== 'undefined' ? res : res.error);
                    if (typeof response.status_code !== 'undefined') {
                        if (response.status_code == 200 && typeof response.data !== 'undefined') {
                            this.isLoading = false;
                            this.notificationService.warningSwal(this.successTitle, 'Formularul dvs. a fost trimis cu succes', this.successIcon)
                                .then(() => {
                                    this.dialogRef.close({ success: true });
                                });
                        }
                    } else {
                        let errorMessage = environment.config.customNotifications.generalMessages.error;
                        this.isLoading = false;
                        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
                    }
                },
                error: (res: any) => {
                    this.isLoading = false;
                    this.onHttpError(res.error);
                    return false;
                }
            });
    }

    addFile(event: any) {
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const currentFiles = this.form.get('files')?.value || [];
            currentFiles.push(file);
            this.form.get('files')?.setValue(currentFiles);

            this.uploading.push(true);

            setTimeout(() => {
                this.uploading.fill(false);

                this.openToast({
                    title: this.successTitle,
                    message: 'Fișierul dvs. a fost adăugat cu succes.',
                    type: this.successIcon
                });
            }, 1000);
        }
    }

    removeFile(index: number) {
        const currentFiles = this.form.get('files')?.value || [];
        currentFiles.splice(index, 1);
        this.uploading.splice(index, 1);
        this.form.get('files')?.setValue(currentFiles);
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(message, title, options, options.iconClasses[type]);
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({ title: this.errorTitle, message: msg, type: this.errorType });
                }
                else {
                    this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
                }
            });
        }
        else {
            let errorMessage = environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        }
    }
}
